/** Período de/até em `Date`: o que o `Calendar` em `selectionMode="range"` entrega, com as duas pontas explícitas. */
export type DateRangeValue = [Date | null, Date | null];

/** Início e fim em ordem cronológica; com só um lado preenchido, mantém `[início, null]`. */
export function orderRange(start: Date | null, end: Date | null): DateRangeValue {
  if (start && end && end.getTime() < start.getTime()) return [end, start];
  return [start, end];
}
